// AUTHORITY-TYPE-PREMIUM-SELECT-001 — premium listbox for Delinquent Authority Type.
// Options come from lib/jurisdictionTaxonomy (state-aware); legacy saved values stay visible but disabled.
import React from 'react';
import { Landmark, Building2, Home, Building, Warehouse, Church, GraduationCap, Network, Map } from 'lucide-react';
import PremiumListbox from './PremiumListbox';
import { getJurisdictionTypeOptionsForState, getJurisdictionTypeLabelForState } from '../../lib/jurisdictionTaxonomy';

const ICONS = {
  county: { Icon: Landmark, tone: 'tcp-tile-blue' },
  city: { Icon: Building2, tone: 'tcp-tile-violet' },
  town: { Icon: Home, tone: 'tcp-tile-indigo' },
  township: { Icon: Warehouse, tone: 'tcp-tile-green' },
  parish: { Icon: Church, tone: 'tcp-tile-amber' },
  borough: { Icon: Building, tone: 'tcp-tile-amber' },
  village: { Icon: Home, tone: 'tcp-tile-violet' },
  school_district: { Icon: GraduationCap, tone: 'tcp-tile-blue' },
  special_district: { Icon: Network, tone: 'tcp-tile-amber' },
};

const AuthorityTypeSelect = ({ value, legacyValue, stateCode, onChange, disabled = false, testId = 'jurisdiction-delinquent-authority-type' }) => {
  const canonical = getJurisdictionTypeOptionsForState(stateCode).map((o) => ({ ...o, ...(ICONS[o.value] || { Icon: Map, tone: 'tcp-tile-indigo' }) }));
  const legacy = legacyValue && !canonical.some((o) => o.value === legacyValue)
    ? [{ value: legacyValue, label: getJurisdictionTypeLabelForState(legacyValue, stateCode), Icon: Map, tone: 'tcp-tile-indigo', disabled: true }]
    : [];
  return (
    <PremiumListbox
      value={value || ''}
      options={[...canonical, ...legacy]}
      onChange={onChange}
      disabled={disabled}
      placeholder="Select type"
      PlaceholderIcon={Map}
      ariaLabel="Authority Type"
      testId={testId}
      className="tcs-root-sm"
    />
  );
};

export default AuthorityTypeSelect;
